import { render, staticRenderFns } from "./NicheDetail.vue?vue&type=template&id=367234a2"
import script from "./NicheDetail.vue?vue&type=script&lang=js"
export * from "./NicheDetail.vue?vue&type=script&lang=js"
import style0 from "./NicheDetail.vue?vue&type=style&index=0&id=367234a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports